const fields = (t) => ({
    config: {columns: 1},
    fields: [
        {
            name: "name",
            label: t ? t("common.name") : "Nazwa",
            column: 1,
            mandatory: true

        },
        {
            name: "comment",
            label: t ? t("common.comment") : "Komentarz",
            column: 1,
            type: "textarea"
        },
    ]
});

export default fields;
